import { IntlShape } from '@redbubble/next/intl';
import { DeviceType } from '@redbubble/next/types';
import { ClickResolveDetails, StripeElements } from '@stripe/stripe-js';
import { fromCart as toLineItems } from '../lineItems';
import { fromCart as toShippingRates } from '../shippingRates';
import { StripeCart } from '../types';
import { getSubunitAmount } from '../utils';

export const handleClick = (
  resolve: (resolveDetails?: ClickResolveDetails) => void,
  elements: StripeElements,
  cart: StripeCart,
  intl: IntlShape,
  isOrAbove: (deviceType: DeviceType) => boolean
): void => {
  // StripeExpress is initialised with an amount on page load which doesn't respond to
  // subsequent cart updates of shipping pref, item quantity, bundle discounts, etc.
  //
  // Do an explicit update of cart amount in Stripe to catch up with /cart.

  const amount = getSubunitAmount(cart.summary.total);

  elements.update({ amount });

  resolve({
    billingAddressRequired: true,
    emailRequired: true,
    phoneNumberRequired: true,
    shippingAddressRequired: true,
    lineItems: toLineItems(cart, intl, isOrAbove),
    shippingRates: toShippingRates(cart, intl),
  });
};
